import { Injectable } from '@angular/core';
import { ChatHttpService } from './chat-http.service';
import { BehaviorSubject, Observable, map, switchMap, take, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  public currentAction=new BehaviorSubject<string>('conversation');
  public conv_id=new BehaviorSubject(null);
  public conv_id$=this.conv_id.asObservable();
  public send_convId=new BehaviorSubject(null)
  senMessage(message: any) {
    return new Observable((observer) => {
      const  token: any =localStorage.getItem(`token`);
      console.log('sendMessage', message);
      const eventSource = new EventSource(   `api/chat/completion?message=${encodeURIComponent(message)}&token=${encodeURIComponent(token)}`);
      eventSource.onopen = (ev) => console.log(ev);
      eventSource.onmessage = (event) => {
        observer.next(event.data);
        if ('[DONE]' == event.data) observer.complete();
      };
      eventSource.onerror = (event) => observer.error(event);
      return () => {
        console.log('eventSource.close');
        eventSource.close();
      };
    });
  }

  constructor(private chatHttp: ChatHttpService) { }
  getMessages(conv_id:any) {
    return this.chatHttp.getMessages(conv_id);
  }

  sendMessage(message:any){
    return this.chatHttp.sendMessage({ message:message,conversation_id:this.send_convId.value }).pipe(
      tap((msg:any)=>(this.send_convId.next(msg?.conv_id))),
      map(data=>data)
    );
  }

  getHistoy(){
    return this.chatHttp.getHistory();
  }
}
